import React from "react";
import TrailTable from "components/common/TrailTable/TrailTable";

interface Props {
  entityId: string | number;
}

const SocialNetworksTrailTab: React.FC<Props> = ({ entityId }) => {
  return (
    <TrailTable entityType="footerSocialNetworks" entityId={Number(entityId)} />
  );
};

export default SocialNetworksTrailTab;
